// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"4b53266b","361":"83d4a5a9","608":"5b92b8b9","674":"d4adfb77","735":"a11b6077","923":"be3b3ed7"}[chunkId] + ".chunk.css";
};